export const IAuthRepositoryType = Symbol('IAuthRepository');
